import React, { Component } from "react";
import { Form, Input, Icon, notification } from "antd";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import Header from "../../User/Header";
import { GlobalContext } from "../../app/providers/GlobalState";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class RegistoPasso1 extends Component {
    static contextType = GlobalContext;
    state = {
        id_utilizador: 0,
        redirect: false,
        redirectLink: "",
        password: ""
    };

    componentDidMount() {
        this.validarToken();
    }

    getParameterByName = name => {
        const match = RegExp("[?&]" + name + "=([^&]*)").exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, " "));
    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChangeCheckbox = event => {
        this.setState({ [event.target.name]: event.target.checked });
    };

    validarToken = () => {
        axios({
            method: "get",
            url: "/api/autenticacaonew/validar-code",
            params: {
                code: this.getParameterByName("code"),
                entidade: true
            }
        })
            .then(response => {
                this.setState({
                    id_utilizador: response.data
                });
                localStorage.setItem("codigo_utilizador", response.data);
            })
            .catch(() => {
                this.erro();
            });
    };

    concluirRegisto = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({ iconLoading: true });

                axios({
                    method: "post",
                    url: "/api/autenticacaonew/registar-admin",
                    params: {
                        userid: this.state.id_utilizador,
                        password: this.state.password
                    }
                })
                    .then(() => {
                        this.setState({
                            redirect: true,
                            redirectLink: "/entidade-registar-passo-2",
                            iconLoading: false
                        });
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível concluir este passo!");
                        this.setState({
                            iconLoading: false
                        });
                    });
            }
        });
    };

    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue("password")) {
            callback("Senhas não coincidentes");
        } else {
            callback();
        }
    };

    validateToNextPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(["confirm"], { force: true });
        }
        callback();
    };

    erro = () => {
        this.setState({
            redirect: true,
            redirectLink: "/pagina-erro"
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { redirect, redirectLink, iconLoading } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        return (
            <>
                <Header titulo="Registro" marginTop0={true} />
                <div className="container">
                    <div className="registar registar-passo6">
                        <div className="header">
                            <div className="passos passos-password">
                                <span>Passo 1</span>
                            </div>
                            <div className="descritivo">
                                <span>Defina a sua senha de acesso para finalizar o registo.</span>
                            </div>
                            <Link to="/" className="btn-close" title="Fechar">
                                <i className="fas fa-times fechar"></i>
                            </Link>
                        </div>
                        <div className="content">
                            <Form className="registar-passo2">
                                <div className="row">
                                    <div className="col-lg-3" />
                                    <div className="col-lg-6">
                                        <Form.Item label="Senha">
                                            {getFieldDecorator("password", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Campo obrigatório"
                                                    },
                                                    {
                                                        pattern: "^(?=.*[A-Z])(?=.*[0-9])(?=.{6,})",
                                                        message: (
                                                            <p>
                                                                A senha deve conter pelo menos uma letra maiúscula, um número e um mínimo de
                                                                6 caracteres
                                                            </p>
                                                        )
                                                    },
                                                    {
                                                        validator: this.validateToNextPassword
                                                    }
                                                ]
                                            })(<Input.Password type="password" name="password" onChange={this.handleChange} />)}
                                        </Form.Item>
                                        <Form.Item label="Confirme a senha">
                                            {getFieldDecorator("confirm", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Campo obrigatório"
                                                    },
                                                    {
                                                        validator: this.compareToFirstPassword
                                                    }
                                                ]
                                            })(<Input.Password type="password" onBlur={this.handleConfirmBlur} />)}
                                        </Form.Item>
                                    </div>
                                    <div className="col-lg-3" />
                                </div>
                                <div className="row">
                                    <div className="col-lg-3" />
                                    <div className="col-lg-6">
                                        <Form.Item className="bloco-controlos" style={{ marginTop: "30px" }}>
                                            <div className="controlos">
                                                <Link
                                                    to="#"
                                                    onClick={() => this.concluirRegisto()}
                                                    disabled={iconLoading}
                                                    className="botao-principal"
                                                >
                                                    {iconLoading ? <Icon type="loading" /> : null}
                                                    Continuar
                                                </Link>
                                            </div>
                                        </Form.Item>
                                    </div>
                                    <div className="col-lg-3" />
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
const FormRegistoPasso1 = Form.create({ name: "registo-passo1" })(RegistoPasso1);

export default FormRegistoPasso1;
